import { Button } from '@mui/material';
import React from 'react';
import { useHistory } from 'react-router';

import User from 'entities/user/model';

import { ActionTemplate } from '../types';

export const EditActionTemplateButton = ({
  actionTemplate,
  user,
}: {
  actionTemplate: ActionTemplate;
  user: User | null;
}) => {
  const history = useHistory();
  const userCanEditTemplate = user?.organization.id === actionTemplate.organizationId;

  return (
    <>
      {userCanEditTemplate && (
        <Button
          color="primary"
          variant="contained"
          onClick={() => {
            history.push(`/actions/template/edit/${actionTemplate.id}`);
          }}
          style={{ margin: '0 0 8px 8px' }}
        >
          <>Edit Template</>
        </Button>
      )}
    </>
  );
};
